<div class="modal-dark">
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
  </div>
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    @if (bodyText) {
      <p>
        {{ bodyText }}
      </p>
    }
  </div>
  <div class="modal-footer">
    @if (buttonTextDismiss) {
      <button
        class="btn btn-outline-dark"
        (click)="onCancel()">
        {{ buttonTextDismiss }}
      </button>
    }
    <button
      class="btn btn-primary"
      type="submit"
      (click)="onAccept()">
      {{ buttonTextAction }}
    </button>
  </div>
</div>
